import {Container} from 'react-bootstrap';
import GifInfiniteScroll from '../../components/gif-infinite-scroll/GifInfiniteScroll';
import GSlider from '../../components/g-slider/GSlider';
import useWindowSize from '../../hooks/useWindowSize';

const Home = () => {
    const {width, height} = useWindowSize();
    return (
        <Container>
            <GSlider
                apiPath={'/search/home-categories'}
                limit={width <= 768 ? 8 : 10}
                sticker={false}
                mainTitle={'GIF Categories'}
                link={'/all-categories'}
                apiPathResName={'categories'}
            />

            <div className="my-3 pt-2">
                <h2 className={'mb-2 mb-lg-4'} style={{fontSize: 'clamp(18px, 3vw, 24px)'}}>Trending GIFs</h2>

                <GifInfiniteScroll
                    apiPath={'/search/resource/featured'}
                    itemsPerPage={width <= 768 ? 6 : height >= 1400 ? 40 : 20}
                />
            </div>
        </Container>
    );
};

export default Home;